// Static content for the Stories — The Millet Café marketing site.
// All copy and imagery are sourced from the brand deck / web reference shared by the user.

export const BRAND = {
  name: "Stories",
  tagline: "The Millet Café",
  primaryLine: "Come for the food. Stay for the conversation.",
  mantra: "Real Food · Real Conversations · Real Impact",
  backedBy: "A Native Touch Café · Backed by EBG Group",
  logoBrown: "https://customer-assets.emergentagent.com/job_bba4f92e-67e0-449a-a7cf-5b7af07843fd/artifacts/f02pq5jm_Stories_logo.png",
  logoWhite: "https://customer-assets.emergentagent.com/job_bba4f92e-67e0-449a-a7cf-5b7af07843fd/artifacts/o3wz9w01_Stories_logo2.png",
  heroAmbience: "https://customer-assets.emergentagent.com/job_bba4f92e-67e0-449a-a7cf-5b7af07843fd/artifacts/zh2x1dtl_stories01.png",
  conversationImage: "https://customer-assets.emergentagent.com/job_millet-stories/artifacts/lubsqlq5_stories02.png",
  storefront: "https://customer-assets.emergentagent.com/job_millet-stories/artifacts/1pcw1epy_01.png",
  foodSpread: "https://customer-assets.emergentagent.com/job_millet-stories/artifacts/j7roe6nk_02.png",
  cozyNook: "https://customer-assets.emergentagent.com/job_millet-stories/artifacts/3zbtjv4p_03.png",
  spacesDwellTime: "https://customer-assets.emergentagent.com/job_millet-stories/artifacts/5yft4h8q_Spaces%20designed%20for%20dwell%20time.png",
  comeForTheFood: "https://customer-assets.emergentagent.com/job_millet-stories/artifacts/qk1wn1c2_Come%20for%20the%20Food.png",
  milletGraphic: "https://customer-assets.emergentagent.com/job_millet-stories/artifacts/qeofadt1_d754a3e7-3a12-4423-b99c-4df4d98d1afd.png",
  social: {
    instagram: "https://instagram.com",
    facebook: "https://facebook.com",
    twitter: "https://twitter.com",
  },
  contact: {
    phone: "+91 98765 43210",
    email: "hello@storiesmilletcafe.in",
    address: "12 Conversation Street, Indiranagar, Bengaluru 560038",
    hours: "Mon — Sun · 8:00 AM — 11:00 PM",
  },
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Menu", to: "/menu" },
  { label: "Gallery", to: "/gallery" },
  { label: "Events", to: "/events" },
  { label: "Locations", to: "/locations" },
  { label: "Franchise", to: "/franchise" },
  { label: "Contact", to: "/contact" },
];

export const PILLARS = [
  {
    title: "Wholesome Millet Menu",
    desc: "Aspirational, delicious, and made with India's most underrated grain.",
  },
  {
    title: "Comforting Café Spaces",
    desc: "Cozy corners designed for dwell time, not just transactions.",
  },
  {
    title: "Conversations that Matter",
    desc: "A café built around the people, the pause and the plate.",
  },
  {
    title: "Conscious by Choice",
    desc: "Sustainable sourcing, mindful service, zero pretense.",
  },
];

export const MENU_CATEGORIES = [
  "All",
  "Coffee",
  "Millet Bakes",
  "Breakfast",
  "Café Meals",
  "Bowls",
  "Pastas",
  "Pizzas",
  "Desserts",
  "Beverages",
];

export const MENU_ITEMS = [
  {
    name: "Foxtail Millet Risotto",
    cat: "Café Meals",
    desc: "Slow-cooked foxtail millet, parmesan, garden herbs, finished with truffle oil.",
    tag: "Chef's Pick",
    img: "https://customer-assets.emergentagent.com/job_millet-stories/artifacts/04an3lk1_Foxtail%20Millet%20Risotto.png",
  },
  {
    name: "Little Millet Buddha Bowl",
    cat: "Bowls",
    desc: "Little millet, roasted vegetables, hummus, tahini drizzle, pomegranate.",
    tag: "Most Loved",
    img: "https://customer-assets.emergentagent.com/job_millet-stories/artifacts/hayb7im5_Little%20Millet%20Buddha%20Bowl.png",
  },
  {
    name: "Ragi Pancake Stack",
    cat: "Breakfast",
    desc: "Stone-ground ragi, jaggery glaze, banana, walnut, a pour of date syrup.",
    tag: "Breakfast Star",
    img: "https://customer-assets.emergentagent.com/job_millet-stories/artifacts/30k16gvz_Ragi%20Pancake%20Stack.png",
  },
  {
    name: "Pearl Millet Pizza",
    cat: "Pizzas",
    desc: "Bajra crust, slow-roasted tomato, burrata, basil, chilli honey.",
    tag: "Crowd Favourite",
    img: "https://customer-assets.emergentagent.com/job_millet-stories/artifacts/umshjrfu_Pearl%20Millet%20Pizza.png",
  },
  {
    name: "Millet Pesto Pasta",
    cat: "Pastas",
    desc: "Kodo millet penne, hand-pounded basil pesto, sun-dried tomato, pine nuts.",
    tag: "Signature",
    img: "https://customer-assets.emergentagent.com/job_millet-stories/artifacts/hl0er8e6_Millet%20Pesto%20Pasta.png",
  },
  {
    name: "Hand-Pulled Filter Coffee",
    cat: "Coffee",
    desc: "Single-origin Chikmagalur beans, slow-poured the South Indian way.",
    tag: "Café Classic",
    img: "https://customer-assets.emergentagent.com/job_millet-stories/artifacts/uk802ngf_Hand-Pulled%20Filter%20Coffee.png",
  },
  {
    name: "Cardamom Oat Latte",
    cat: "Coffee",
    desc: "Double espresso, oat milk, a whisper of green cardamom.",
    tag: "Barista Pick",
    img: "https://customer-assets.emergentagent.com/job_millet-stories/artifacts/k4l7ecct_Cardamom%20Oat%20Latte.png",
  },
  {
    name: "Jowar Chocolate Brownie",
    cat: "Millet Bakes",
    desc: "Fudgy jowar brownie, sea salt, single-origin 70% chocolate.",
    tag: "Bakehouse",
    img: "https://images.unsplash.com/photo-1606313564200-e75d5e30476c?auto=format&fit=crop&w=900&q=80",
  },
  {
    name: "Bajra Banana Loaf",
    cat: "Millet Bakes",
    desc: "Bajra & whole wheat, ripe bananas, toasted walnuts, jaggery.",
    tag: "Daily Bake",
    img: "https://images.unsplash.com/photo-1606101273945-e9eba91c0dc4?auto=format&fit=crop&w=900&q=80",
  },
  {
    name: "Turmeric Latte",
    cat: "Beverages",
    desc: "Golden milk, fresh ginger, organic turmeric, a touch of honey.",
    tag: "Wellness",
    img: "https://customer-assets.emergentagent.com/job_millet-stories/artifacts/dkjdwp9l_Turmeric%20Latte.png",
  },
  {
    name: "Cold Pressed Sunrise",
    cat: "Beverages",
    desc: "Carrot, orange, ginger, turmeric. Bottled at the bar.",
    tag: "Fresh",
    img: "https://images.unsplash.com/photo-1622597467836-f3285f2131b8?auto=format&fit=crop&w=900&q=80",
  },
  {
    name: "Saffron Kheer Pot",
    cat: "Desserts",
    desc: "Little millet kheer, Kashmiri saffron, slivered pistachio.",
    tag: "Sweet Finish",
    img: "https://images.unsplash.com/photo-1551024506-0bccd828d307?auto=format&fit=crop&w=900&q=80",
  },
];

export const SPACES = [
  {
    name: "Couple Corner",
    desc: "Soft light, low chatter, a table built for two.",
    best: "2 guests · Date · Catch-up",
    img: "https://customer-assets.emergentagent.com/job_millet-stories/artifacts/t466rto2_Couple%20Corner.png",
  },
  {
    name: "Conversation Table",
    desc: "Long bench, shared plates, evenings that linger.",
    best: "4 — 6 guests · Friends · Family",
    img: "https://customer-assets.emergentagent.com/job_millet-stories/artifacts/gx8gwynr_Conversation%20Table.png",
  },
  {
    name: "Quiet Work Nook",
    desc: "Fast Wi-Fi, charging points, deep-focus playlist.",
    best: "Solo · Founders · Writers",
    img: "https://customer-assets.emergentagent.com/job_millet-stories/artifacts/6xxygmnf_Quiet%20Work%20Nook.png",
  },
  {
    name: "Reading Window",
    desc: "Plant-side window seat for slow afternoons and dog-eared pages.",
    best: "Solo · Reader · Coffee",
    img: "https://customer-assets.emergentagent.com/job_millet-stories/artifacts/i4o77pcw_Reading%20Window.png",
  },
];

export const EVENTS = [
  {
    type: "Open Mic",
    title: "Open Mic Sundays",
    date: "Every Sunday · 6:30 PM",
    city: "Bengaluru · Indiranagar",
    desc: "Poets, songwriters and storytellers — bring a piece, take a stage.",
    seats: 14,
    img: "https://customer-assets.emergentagent.com/job_millet-stories/artifacts/g6tsz8uv_Open%20Mic%20Sundays.png",
  },
  {
    type: "Book Reading",
    title: "Chai & Chapters Book Club",
    date: "2nd Saturday · 5:00 PM",
    city: "Bengaluru · Koramangala",
    desc: "A new book each month. Slow reading, shared cups, real talk.",
    seats: 18,
    img: "https://customer-assets.emergentagent.com/job_millet-stories/artifacts/ovwvspp2_Chai%20%26%20Chapters%20Book%20Club.png",
  },
  {
    type: "Startup Meetup",
    title: "Founders Over Filter Coffee",
    date: "Last Friday · 7:30 PM",
    city: "Hyderabad · Banjara Hills",
    desc: "Casual founders' night. No pitches. Just notes, coffee and millet bites.",
    seats: 32,
    img: "https://customer-assets.emergentagent.com/job_millet-stories/artifacts/ivniwsew_Founders%20Over%20Filter%20Coffee.png",
  },
  {
    type: "Workshop",
    title: "Millet Sourdough Workshop",
    date: "Sat, 22 Feb · 11:00 AM",
    city: "Bengaluru · Indiranagar",
    desc: "Two-hour hands-on. Mix, fold, taste. Take a loaf home.",
    seats: 10,
    img: "https://customer-assets.emergentagent.com/job_millet-stories/artifacts/8oq0qyqu_Millet%20Sourdough%20Workshop.png",
  },
  {
    type: "Couple Celebration",
    title: "Anniversary Tasting Menu",
    date: "By reservation",
    city: "All Stories cafés",
    desc: "Curated six-course millet tasting for two, with a handwritten note from the chef.",
    seats: 6,
    img: "https://customer-assets.emergentagent.com/job_millet-stories/artifacts/l4lq03eu_Anniversary%20Tasting%20Menu.png",
  },
  {
    type: "Birthday",
    title: "Birthday at Stories",
    date: "Book the corner",
    city: "All Stories cafés",
    desc: "Cake, candles and millet cookies. Reserve a corner, leave the planning to us.",
    seats: 20,
    img: "https://customer-assets.emergentagent.com/job_millet-stories/artifacts/p7dy1rvp_Birthday%20at%20Stories.png",
  },
];

export const LOCATIONS = [
  {
    city: "Bengaluru",
    name: "Stories · Indiranagar",
    addr: "12 Conversation Street, Indiranagar, Bengaluru 560038",
    hours: "8:00 AM — 11:00 PM · Mon to Sun",
    phone: "+91 98765 43210",
    tags: ["Events", "Date-friendly", "Best for work"],
    img: "https://customer-assets.emergentagent.com/job_millet-stories/artifacts/1pcw1epy_01.png",
  },
  {
    city: "Bengaluru",
    name: "Stories · Koramangala",
    addr: "5th Block, Koramangala, Bengaluru 560095",
    hours: "8:30 AM — 11:00 PM · Mon to Sun",
    phone: "+91 98765 43211",
    tags: ["Open Now", "Book Club", "Outdoor"],
    img: "https://customer-assets.emergentagent.com/job_millet-stories/artifacts/lubsqlq5_stories02.png",
  },
  {
    city: "Hyderabad",
    name: "Stories · Banjara Hills",
    addr: "Road No. 12, Banjara Hills, Hyderabad 500034",
    hours: "9:00 AM — 11:30 PM · Mon to Sun",
    phone: "+91 98765 43212",
    tags: ["Founders' Night", "Date-friendly", "Lounge"],
    img: "https://customer-assets.emergentagent.com/job_bba4f92e-67e0-449a-a7cf-5b7af07843fd/artifacts/zh2x1dtl_stories01.png",
  },
  {
    city: "Mumbai",
    name: "Stories · Bandra West",
    addr: "Pali Hill, Bandra West, Mumbai 400050",
    hours: "8:00 AM — 12:00 AM · Mon to Sun",
    phone: "+91 98765 43213",
    tags: ["Events", "Open Mic", "Best for work"],
    img: "https://customer-assets.emergentagent.com/job_millet-stories/artifacts/3zbtjv4p_03.png",
  },
  {
    city: "Pune",
    name: "Stories · Koregaon Park",
    addr: "North Main Road, Koregaon Park, Pune 411001",
    hours: "8:00 AM — 11:00 PM · Mon to Sun",
    phone: "+91 98765 43214",
    tags: ["Garden", "Date-friendly", "Workshops"],
    img: "https://customer-assets.emergentagent.com/job_millet-stories/artifacts/j7roe6nk_02.png",
  },
  {
    city: "Delhi",
    name: "Stories · Khan Market",
    addr: "Khan Market, New Delhi 110003",
    hours: "8:30 AM — 11:30 PM · Mon to Sun",
    phone: "+91 98765 43215",
    tags: ["Open Now", "Lounge", "Events"],
    img: "https://customer-assets.emergentagent.com/job_millet-stories/artifacts/5yft4h8q_Spaces%20designed%20for%20dwell%20time.png",
  },
];

export const GALLERY_IMAGES = [
  "https://customer-assets.emergentagent.com/job_bba4f92e-67e0-449a-a7cf-5b7af07843fd/artifacts/zh2x1dtl_stories01.png",
  "https://customer-assets.emergentagent.com/job_millet-stories/artifacts/lubsqlq5_stories02.png",
  "https://customer-assets.emergentagent.com/job_millet-stories/artifacts/qk1wn1c2_Come%20for%20the%20Food.png",
  "https://customer-assets.emergentagent.com/job_millet-stories/artifacts/1pcw1epy_01.png",
  "https://customer-assets.emergentagent.com/job_millet-stories/artifacts/j7roe6nk_02.png",
  "https://customer-assets.emergentagent.com/job_millet-stories/artifacts/3zbtjv4p_03.png",
  "https://customer-assets.emergentagent.com/job_millet-stories/artifacts/5yft4h8q_Spaces%20designed%20for%20dwell%20time.png",
  "https://customer-assets.emergentagent.com/job_millet-stories/artifacts/g6tsz8uv_Open%20Mic%20Sundays.png",
  "https://customer-assets.emergentagent.com/job_millet-stories/artifacts/ovwvspp2_Chai%20%26%20Chapters%20Book%20Club.png",
  "https://customer-assets.emergentagent.com/job_millet-stories/artifacts/ivniwsew_Founders%20Over%20Filter%20Coffee.png",
  "https://customer-assets.emergentagent.com/job_millet-stories/artifacts/8oq0qyqu_Millet%20Sourdough%20Workshop.png",
  "https://customer-assets.emergentagent.com/job_millet-stories/artifacts/l4lq03eu_Anniversary%20Tasting%20Menu.png",
  "https://customer-assets.emergentagent.com/job_millet-stories/artifacts/p7dy1rvp_Birthday%20at%20Stories.png",
  "https://customer-assets.emergentagent.com/job_millet-stories/artifacts/t466rto2_Couple%20Corner.png",
  "https://customer-assets.emergentagent.com/job_millet-stories/artifacts/gx8gwynr_Conversation%20Table.png",
  "https://customer-assets.emergentagent.com/job_millet-stories/artifacts/6xxygmnf_Quiet%20Work%20Nook.png",
  "https://customer-assets.emergentagent.com/job_millet-stories/artifacts/i4o77pcw_Reading%20Window.png",
  "https://customer-assets.emergentagent.com/job_millet-stories/artifacts/04an3lk1_Foxtail%20Millet%20Risotto.png",
  "https://customer-assets.emergentagent.com/job_millet-stories/artifacts/hayb7im5_Little%20Millet%20Buddha%20Bowl.png",
  "https://customer-assets.emergentagent.com/job_millet-stories/artifacts/30k16gvz_Ragi%20Pancake%20Stack.png",
  "https://customer-assets.emergentagent.com/job_millet-stories/artifacts/umshjrfu_Pearl%20Millet%20Pizza.png",
  "https://customer-assets.emergentagent.com/job_millet-stories/artifacts/hl0er8e6_Millet%20Pesto%20Pasta.png",
  "https://customer-assets.emergentagent.com/job_millet-stories/artifacts/uk802ngf_Hand-Pulled%20Filter%20Coffee.png",
  "https://customer-assets.emergentagent.com/job_millet-stories/artifacts/k4l7ecct_Cardamom%20Oat%20Latte.png",
  "https://customer-assets.emergentagent.com/job_millet-stories/artifacts/dkjdwp9l_Turmeric%20Latte.png",
];

export const FRANCHISE_BENEFITS = [
  { title: "Proven Café Model", desc: "A conversation-first format with strong unit economics across formats." },
  { title: "EBG Group Backing", desc: "Operations, marketing & sourcing playbooks from a battle-tested F&B group." },
  { title: "Two Formats", desc: "Stories Café (compact, high-turn) and Stories Café Lounge (community-led)." },
  { title: "End-to-End Setup", desc: "Site selection, design, kitchen, training, launch — we walk the journey with you." },
  { title: "Millet-First Menu", desc: "An aspirational menu people actually crave — built for daily repeat visits." },
  { title: "Real Brand Power", desc: "A young, distinctive brand that travels across cities and customer cohorts." },
];

export const STORIES_NUMBERS = [
  { value: "1st", label: "Millet café chain in India" },
  { value: "9+", label: "Menu categories crafted with millets" },
  { value: "6", label: "Cities live & coming soon" },
  { value: "100%", label: "No maida · No preservatives" },
];
